import { productNameForLocale } from "../../branding/productBrand";

const productName = productNameForLocale("ru");

export const ruLocale = {
  login: {
    eyebrow: productName,
    titles: {
      signIn: "Войдите, чтобы продолжить",
      register: "Создайте аккаунт",
    },
    description: "Мобильный интерфейс диалогов и чатов через gateway edge.",
    modeSelectorAria: "Режим аутентификации",
    actions: {
      signIn: "Войти",
      register: "Регистрация",
      createAccount: "Создать аккаунт",
      confirmRegistration: "Подтвердить код",
      showPassword: "Показать",
      hidePassword: "Скрыть",
      pleaseWait: "Подождите...",
    },
    identifierLabel: "Почта",
    identifierPlaceholder: "you@example.com",
    registerIdentifierLabel: "Почта",
    registerIdentifierPlaceholder: "you@example.com",
    displayNameLabel: "Видимое имя",
    displayNamePlaceholder: "Ада Лавлейс",
    displayNameHint: "Показывается в чатах и контактах. Используйте 1-64 символа.",
    passwordLabel: "Пароль",
    passwordPlaceholder: "Введите пароль",
    keepSignedIn: {
      label: "Оставаться в аккаунте",
      helper: "Вход сохранится после перезапуска браузера на этом устройстве. Снимите флажок для входа только в текущей сессии.",
    },
    confirmPasswordLabel: "Подтвердите пароль",
    confirmPasswordPlaceholder: "Повторите пароль",
    registrationDisclaimer: {
      title: "Условия регистрации и ответственность",
      body: [
        "Регистрируясь в сервисе, я подтверждаю, что понимаю и принимаю условия использования сервиса в пределах, допускаемых применимым законодательством Российской Федерации.",
        "Я обязуюсь использовать сервис законно и самостоятельно несу ответственность за содержание сообщений, файлов, имен, описаний групп/каналов и иных материалов, которые я создаю, отправляю или распространяю через сервис.",
        "Сервис предоставляется для обмена сообщениями \"как есть\" в той мере, в какой это допускается законом. Оператор не гарантирует непрерывную доступность, отсутствие ошибок, совместимость со всеми устройствами или невозможность сбоев связи, инфраструктуры, браузера, PWA, сети, хранилища или сторонних сервисов.",
        "Оператор не несет ответственности за действия пользователей, пользовательские материалы, последствия незаконного использования сервиса, а также за убытки, вызванные обстоятельствами вне разумного контроля оператора, кроме случаев, когда такая ответственность не может быть ограничена по обязательным нормам закона.",
        "Мой адрес электронной почты или номер телефона, пароль в виде защищенного хэша, данные сессии и технические данные аккаунта обрабатываются для регистрации, входа, защиты сессии, работы сообщений и выполнения обязанностей оператора согласно применимому законодательству о персональных данных.",
        "Если какие-либо положения этого уведомления противоречат обязательным правам пользователя или требованиям закона, такие обязательные нормы имеют приоритет.",
      ],
      versionLabel: "Версия условий",
      acceptLabel: "Я прочитал(а) и принимаю эти условия регистрации",
    },
    registrationConfirmation: {
      title: "Подтвердите почту",
      body: "Введите код подтверждения, отправленный на {{email}}.",
      emailLabel: "Почта",
      expiresLabel: "Истекает",
      codeLabel: "Код подтверждения",
      codePlaceholder: "12345678",
      resend: "Отправить код еще раз",
      resending: "Отправляем...",
      resendSent: "Новый код отправлен.",
      resendAvailable: "Повторная отправка доступна после {{time}}",
    },
    errors: {
      invalidRequest: "Проверка запроса не пройдена. Проверьте данные и повторите.",
      unauthorized: "Неверные учетные данные. Повторите попытку.",
      identifierTaken: "Такой аккаунт уже существует. Выполните вход.",
      disclaimerRequired: "Примите условия регистрации, чтобы создать аккаунт.",
      phoneRegistrationUnavailable: "Регистрация по телефону временно недоступна. Зарегистрируйтесь по почте.",
      registrationNotFound: "Ожидающая регистрация для этой почты не найдена. Начните регистрацию заново.",
      invalidConfirmationCode: "Код подтверждения неверный. Проверьте код и повторите.",
      confirmationExpired: "Срок действия кода истек. Начните регистрацию заново или запросите новый код.",
      confirmationRateLimited: "Слишком много попыток подтверждения. Подождите и повторите.",
      registrationDeliveryUnavailable: "Сейчас не удалось отправить письмо с кодом. Повторите позже.",
      confirmationCodeRequired: "Введите код подтверждения из письма.",
      displayNameRequired: "Введите видимое имя.",
      displayNameInvalid: "Видимое имя должно быть не длиннее 64 символов.",
      requestFailed: "Запрос не выполнен. Повторите попытку.",
      unexpected: "Непредвиденная ошибка. Повторите попытку.",
      identifierPasswordRequired: "Требуются почта и пароль.",
      passwordMismatch: "Пароли не совпадают.",
    },
  },
  notifications: {
    install: {
      title: "Включите push-уведомления на iPhone",
      body: `Push-уведомления на iPhone работают после запуска ${productName} с экрана Домой в режиме web-app.`,
      steps: [
        "В Safari нажмите Поделиться и выберите На экран Домой.",
        "Откройте приложение с экрана Домой и оставьте включенным режим Web App.",
        "Разрешите уведомления по запросу внутри установленного приложения.",
      ],
    },
    permission: {
      title: "Включите push-уведомления",
      body: "Разрешите уведомления, чтобы новые сообщения появлялись, когда приложение закрыто или в фоне.",
      action: "Включить уведомления",
      enabling: "Включаем...",
    },
  },
  contacts: {
    entry: {
      open: "Открыть контакты",
      close: "Закрыть контакты",
    },
    panel: {
      eyebrow: "Контакты",
      title: "Сохраненные люди",
      close: "Закрыть контакты",
      reload: "Обновить контакты",
    },
    lookup: {
      label: "Почта, телефон или user id",
      placeholder: "alice@example.com или usr_alice",
    },
    actions: {
      add: "Добавить контакт",
      adding: "Добавление контакта",
      remove: "Удалить {{name}}",
      removing: "Удаление {{name}}",
      startChat: "Начать чат с {{name}}",
      startingChat: "Запуск чата с {{name}}",
    },
    states: {
      loading: "Загрузка контактов...",
      empty: "Пока нет сохраненных контактов.",
      added: "Контакт добавлен.",
      removed: "Контакт удален.",
    },
    accessibility: {
      avatarFallback: "Аватар для {{name}}",
    },
    errors: {
      duplicate: "Этот человек уже в ваших контактах.",
      notFound: "Пользователь с таким идентификатором не найден.",
      contactNotFound: "Этот контакт больше не сохранен.",
      invalid: "Введите корректную почту, телефон или user id.",
      self: "Нельзя добавить себя в контакты.",
      unauthorized: "Сессия истекла. Войдите снова.",
      forbidden: "У вас нет прав управлять контактами.",
      load: "Не удалось загрузить контакты.",
      add: "Не удалось добавить контакт.",
      remove: "Не удалось удалить контакт.",
      startChat: "Не удалось начать чат.",
      generic: "Сейчас не удалось управлять контактами.",
    },
  },
  chatList: {
    shell: {
      workspaceEyebrow: "Рабочее пространство",
      title: "Разговоры",
      openProfilePanel: "Открыть панель фото профиля",
      signOut: "Выйти",
      newChat: "Новый чат",
      openTypeMenu: "Открыть меню типов чатов",
      closeTypeMenu: "Закрыть меню типов чатов",
      recentConversations: "Недавние разговоры",
      refreshConversations: "Обновить разговоры",
      loading: "Загрузка разговоров...",
      empty: "Пока нет разговоров. Начните чат через меню +.",
      profileFallback: "Я",
    },
    chatTypes: {
      direct: {
        label: "Личный",
        note: "Один на один",
      },
      group: {
        label: "Группа",
        note: "Обсуждение",
      },
      channel: {
        label: "Канал",
        note: "Публикации",
      },
      secret: {
        label: "Секретный",
        note: "E2EE в 14-03",
      },
    },
    preview: {
      direct: "Личный разговор",
      group: "Групповое обсуждение",
      channel: "Обновления канала",
      secret: "Секретный чат",
      fallback: "Разговор",
    },
    avatarPreview: {
      open: "Открыть предпросмотр аватара: {{label}}",
      close: "Закрыть предпросмотр аватара",
      dialog: "Предпросмотр аватара: {{label}}",
      image: "Увеличенный аватар: {{label}}",
    },
    unread: {
      rowLabel: "{{title}}, непрочитанных сообщений: {{count}}",
    },
    shared: {
      add: "Добавить",
      remove: "Удалить",
      removeWithIdentifier: "Удалить {{identifier}}",
    },
    direct: {
      title: "Личный чат",
      closePanel: "Закрыть панель личного чата",
      peerLabel: "Почта или user id собеседника",
      peerPlaceholder: "you@example.com или usr_peer",
      creatingAria: "Создание чата",
      startAria: "Начать личный чат",
    },
    group: {
      title: "Создать группу",
      closePanel: "Закрыть панель группы",
      nameLabel: "Название группы",
      namePlaceholder: "release",
      descriptionLabel: "Описание (опционально)",
      descriptionPlaceholder: "Координация релиза и заметки по запуску",
      avatarLabel: "Аватар (опционально)",
      avatarSelected: "Аватар: {{fileName}}",
      addMemberLabel: "Добавить участника по почте, телефону или user id",
      memberPlaceholder: "alice@example.com или usr_alice",
      creating: "Создание группы...",
      create: "Создать группу",
    },
    channel: {
      title: "Создать канал",
      closePanel: "Закрыть панель канала",
      nameLabel: "Название канала",
      namePlaceholder: "announcements",
      descriptionLabel: "Описание (опционально)",
      descriptionPlaceholder: "Обновления релиза для всего пространства",
      avatarLabel: "Аватар (опционально)",
      avatarSelected: "Аватар: {{fileName}}",
      addPublisherLabel: "Добавить издателя по почте, телефону или user id",
      publisherPlaceholder: "publisher@example.com или usr_pub",
      creating: "Создание канала...",
      create: "Создать канал",
    },
    secret: {
      title: "Секретный чат",
      closePanel: "Закрыть панель секретного чата",
      peerLabel: "Почта, телефон или user id собеседника",
      peerPlaceholder: "alice@example.com",
      creatingAria: "Создание секретного чата",
      startAria: "Начать секретный чат",
      badge: "Секретный",
    },
    validation: {
      nameRequired: "Название обязательно.",
      nameOneWord: "Название должно быть одним словом без пробелов.",
      nameMax: "Название должно быть не длиннее 64 символов.",
      descriptionSingleLine: "Описание должно быть в одну строку.",
      descriptionMax: "Описание должно быть не длиннее 280 символов.",
      groupReady: "Группа готова к созданию.",
      groupRequirements: "Нужно однословное название и хотя бы один участник.",
      channelReady: "Канал готов к созданию.",
      channelRequirements: "Нужно однословное название и хотя бы один издатель.",
    },
    errors: {
      loadConversations: "Не удалось загрузить разговоры",
      loadProfile: "Не удалось загрузить профиль",
      directPeerIdentifierRequired: "Требуется почта или user id собеседника.",
      peerIdentifierRequired: "Требуется почта, телефон или user id собеседника.",
      groupMemberIdentifierRequired: "Требуется идентификатор участника.",
      channelPublisherIdentifierRequired: "Требуется идентификатор издателя.",
      groupAtLeastOneMember: "Добавьте хотя бы одного участника.",
      channelAtLeastOnePublisher: "Добавьте хотя бы одного издателя.",
      secretUserNotFound: "Пользователь с такой почтой или телефоном не найден.",
      secretInvalidIdentifier: "Введите корректную почту, телефон или user id.",
      secretForbidden: "У вас нет прав создавать секретный чат.",
      secretCreateFallback: "Не удалось создать секретный чат",
      directCreateFallback: "Не удалось создать личный чат",
      groupMembersNotFound: "Не удалось определить одного или нескольких участников.",
      channelPublishersNotFound: "Не удалось определить одного или нескольких издателей.",
      groupInvalidRequest: "Укажите однословное название группы, корректное описание и хотя бы одного участника.",
      channelInvalidRequest: "Укажите однословное название канала, корректное описание и хотя бы одного издателя.",
      groupConflict: "Группа с такими параметрами уже существует.",
      channelConflict: "Канал с такими параметрами уже существует.",
      groupForbidden: "У вас нет прав создавать эту группу.",
      channelForbidden: "У вас нет прав создавать этот канал.",
      groupCreateFallback: "Не удалось создать группу",
      channelCreateFallback: "Не удалось создать канал",
      avatarNotFound: "Выбранный файл аватара больше недоступен.",
      avatarProcessing: "Аватар еще обрабатывается. Повторите через пару секунд.",
      avatarInvalid: "Выберите корректный файл изображения для аватара.",
      avatarUploadFallback: "Не удалось загрузить аватар сейчас.",
    },
  },
  chatThread: {
    shell: {
      eyebrow: "Разговор",
      secretConversation: "Секретный разговор",
    },
    notifications: {
      unavailableTitle: "Разговор недоступен",
      unavailableBody:
        "Это уведомление указывает на чат, который недоступен или ограничен. Вернитесь к списку чатов, чтобы продолжить.",
      dismiss: "Закрыть",
      backToChats: "К чатам",
    },
    composer: {
      secretPlaceholder: "Введите зашифрованный payload",
      messagePlaceholder: "Напишите сообщение",
      noAccessPlaceholder: "Для отправки сообщений нужен доступ к чату",
    },
    timeline: {
      loading: "Загрузка ленты...",
      empty: "Пока нет сообщений. Начните разговор.",
      deleted: "Удалено",
      messageDeleted: "Сообщение удалено",
      loadVoice: "Загрузить голос",
      loadPhoto: "Загрузить фото",
      openFullSizePhoto: "Открыть фото в полном размере",
      photoAttachmentAlt: "Фото-вложение",
      photoAttachmentFullAlt: "Фото-вложение в полном размере",
      photoPreview: "Предпросмотр фото",
      closePhotoPreview: "Закрыть предпросмотр фото",
      photoLoading: "Загрузка фото в полном размере...",
      photoLoadFailed: "Фото в полном размере недоступно",
      photoFailed: "Не удалось отправить фото",
      photoSending: "Отправка фото",
      voiceFailed: "Не удалось отправить голос",
      voiceSending: "Отправка голоса",
      voiceMaxReached: "Достигнут максимум",
      voiceDuration: "Длительность",
    },
    receipts: {
      sent: "Отправлено",
      read: "Прочитано",
    },
    references: {
      reply: "Ответ",
      forwarded: "Переслано",
      attachment: "Вложение",
      unavailable: "Исходное сообщение недоступно",
      openReply: "Открыть сообщение ответа {{sequence}}",
    },
    forward: {
      title: "Переслать в",
      loading: "Загрузка разговоров...",
      empty: "Нет доступных разговоров",
      errors: {
        targets: "Не удалось загрузить разговоры.",
        unavailable: "Не удалось переслать в этот разговор.",
        invalid: "Запрос пересылки некорректен.",
        unauthorized: "Войдите снова, чтобы переслать это сообщение.",
        failed: "Не удалось переслать сообщение.",
      },
    },
    selection: {
      mode: "Сообщение выбрано",
      actionMenu: "Действия выбранного сообщения",
      dismiss: "Скрыть действия выбранного сообщения",
      escapeDismiss: "Нажмите Escape, чтобы скрыть действия выбранного сообщения",
    },
    voice: {
      title: "Голосовое сообщение",
      cancel: "Отмена",
      reachedMax: "Достигнута максимальная длительность ({{duration}})",
      recorded: "Записано {{duration}}",
      starting: "Запуск...",
      recordingHoldHint: "Идет запись… отпустите для предпросмотра",
      holdToRecord: "Удерживайте для записи",
      max: "Макс {{duration}}",
    },
    actions: {
      saveEdit: "Сохранить правку",
      cancelEdit: "Отменить правку",
      replyMessage: "Ответить на сообщение",
      forwardMessage: "Переслать сообщение",
      cancelReply: "Отменить ответ",
      cancelForward: "Отменить пересылку",
      editMessage: "Редактировать сообщение",
      deleteMessage: "Удалить сообщение",
      revealMessageActions: "Удерживайте или нажмите Enter, чтобы показать действия сообщения",
      retryPhoto: "Повторить фото",
      deletePendingPhoto: "Удалить ожидающее фото",
      retryVoice: "Повторить голос",
      deletePendingVoice: "Удалить ожидающий голос",
      hideMetadataEditor: "Скрыть редактор метаданных",
      editMetadata: "Редактировать метаданные",
      hideManageMembers: "Скрыть управление участниками",
      manageMembers: "Управление участниками",
      hideSearch: "Скрыть поиск",
      showSearch: "Показать поиск",
      back: "Назад",
      send: "Отправить",
      delete: "Удалить",
      mediaActions: "Медиа-действия",
      photo: "Фото",
      voice: "Голос",
      file: "Файл",
      removeFile: "Убрать файл",
      loadFile: "Загрузить файл",
      downloadFile: "Скачать {{filename}}",
      sendMessage: "Отправить сообщение",
    },
    files: {
      attachment: "Файл",
      ready: "Готов",
      uploading: "Загрузка",
      uploadingProgress: "Загрузка {{progress}}%",
      loading: "Загрузка файла",
      failed: "Ошибка",
      errors: {
        invalid: "Тип файла не разрешен.",
        rejected: "Файл отклонен.",
        unauthorized: "Войдите снова, чтобы отправить файл.",
        failed: "Не удалось отправить файл.",
        downloadFailed: "Не удалось скачать файл.",
      },
    },
    metadataEditor: {
      title: "Редактировать метаданные",
      helper: "Задайте однословное название и опциональное однострочное описание.",
      nameLabelGroup: "Название группы",
      nameLabelChannel: "Название канала",
      namePlaceholderGroup: "group_name",
      namePlaceholderChannel: "channel_name",
      descriptionLabel: "Описание",
      descriptionPlaceholder: "Опциональное однострочное описание",
      avatarLabel: "Аватар (опционально)",
      avatarQueued: "Аватар в очереди: {{fileName}}",
      avatarWillBeRemoved: "Аватар будет удален после сохранения.",
      avatarRequiredForReplace: "Выберите изображение аватара для загрузки.",
      avatarActions: {
        remove: "Удалить аватар",
        keep: "Оставить текущий",
      },
      validation: {
        ready: "Метаданные готовы к сохранению.",
        nameRequired: "Название обязательно.",
        nameOneWord: "Название должно быть одним словом без пробелов.",
        nameMax: "Название должно быть не длиннее {{max}} символов.",
        descriptionSingleLine: "Описание должно быть в одну строку.",
        descriptionMax: "Описание должно быть не длиннее {{max}} символов.",
      },
      actions: {
        close: "Закрыть",
        saving: "Сохранение...",
        save: "Сохранить метаданные",
      },
      success: {
        groupUpdated: "Метаданные группы обновлены.",
        channelUpdated: "Метаданные канала обновлены.",
      },
      errors: {
        invalidRequest: "Введите корректное однословное название и описание.",
        forbiddenGroup: "У вас нет прав обновлять эту группу.",
        forbiddenChannel: "У вас нет прав обновлять этот канал.",
        notFoundGroup: "Эта группа больше не существует.",
        notFoundChannel: "Этот канал больше не существует.",
        conflictGroup: "Обновление метаданных группы конфликтует с параллельным изменением.",
        conflictChannel: "Обновление метаданных канала конфликтует с параллельным изменением.",
        updateFailedGroup: "Не удалось обновить метаданные группы. Повторите попытку.",
        updateFailedChannel: "Не удалось обновить метаданные канала. Повторите попытку.",
        avatarNotFound: "Выбранный файл аватара больше недоступен.",
        avatarProcessing: "Загрузка аватара еще обрабатывается. Повторите через пару секунд.",
        avatarInvalid: "Выберите корректный файл изображения для аватара.",
        avatarUploadFailed: "Не удалось загрузить аватар сейчас.",
      },
    },
    manageMembers: {
      title: "Управление участниками",
      helper: {
        canAdd: "Добавляйте по почте/телефону/user ID и удаляйте существующих участников.",
        groupLeaveOnly: "Вы можете покинуть эту группу, но добавлять участников могут только администраторы.",
        channelLeaveOnly: "Вы можете покинуть этот канал, но добавлять подписчиков могут только администраторы/издатели.",
      },
      empty: "Нет участников для модерации.",
      identifierLabel: "Идентификатор",
      identifierPlaceholder: "email@example.com, +15550000000 или usr_...",
      state: {
        protected: "Защищен",
      },
      actions: {
        close: "Закрыть",
        adding: "Добавление...",
        addMember: "Добавить участника",
        addSubscriber: "Добавить подписчика",
        leaving: "Выход...",
        removing: "Удаление...",
        leave: "Покинуть",
        remove: "Удалить",
      },
      success: {
        memberAdded: "Участник добавлен.",
        subscriberAdded: "Подписчик добавлен.",
        memberRemoved: "Участник удален.",
        subscriberRemoved: "Подписчик удален.",
      },
      errors: {
        identifierRequired: "Введите почту, телефон или user ID.",
        invalidIdentifier: "Введите корректную почту, телефон или user ID.",
        userNotFound: "Пользователь с таким идентификатором не найден.",
        addForbiddenGroup: "У вас нет прав добавлять участников в эту группу.",
        addForbiddenChannel: "У вас нет прав добавлять подписчиков в этот канал.",
        alreadyMember: "Этот пользователь уже состоит в группе.",
        alreadySubscriber: "Этот пользователь уже подписан на канал.",
        addFailedGroup: "Не удалось добавить участника. Повторите попытку.",
        addFailedChannel: "Не удалось добавить подписчика. Повторите попытку.",
        removeInvalidSelection: "Выберите корректного участника для удаления.",
        removeNotFoundGroup: "Этот участник больше не состоит в группе.",
        removeNotFoundChannel: "Этот подписчик больше не состоит в канале.",
        removeForbiddenGroup: "У вас нет прав удалять участников из этой группы.",
        removeForbiddenChannel: "У вас нет прав удалять подписчиков из этого канала.",
        removeConflictGroup: "Этого участника нельзя удалить из-за ограничений роли.",
        removeConflictChannel: "Этого подписчика нельзя удалить из-за ограничений роли.",
        removeFailedGroup: "Не удалось удалить участника. Повторите попытку.",
        removeFailedChannel: "Не удалось удалить подписчика. Повторите попытку.",
      },
    },
    lifecycle: {
      title: "Управление жизненным циклом",
      helper: "Закрытие сохраняет историю доступной для чтения. Удаление скрывает разговор из активных списков.",
      closedState: "Этот разговор закрыт. История доступна для чтения, но отправка и управление отключены.",
      confirmationLabel: "Введите {{phrase}} для подтверждения",
      confirmationPlaceholder: "Текст подтверждения",
      confirmationRequirement: "Разрушительные действия включаются только после совпадения текста подтверждения.",
      actions: {
        cancel: "Отмена",
        closeGroup: "Закрыть группу",
        closeChannel: "Закрыть канал",
        removeGroup: "Удалить группу",
        removeChannel: "Удалить канал",
        confirmClose: "Подтвердить закрытие",
        confirmRemove: "Подтвердить удаление",
        closing: "Закрытие...",
        removing: "Удаление...",
      },
      success: {
        groupClosed: "Группа закрыта.",
        channelClosed: "Канал закрыт.",
        groupRemoved: "Группа удалена.",
        channelRemoved: "Канал удален.",
      },
      errors: {
        closeInvalidGroup: "Запрос на закрытие группы некорректен.",
        closeInvalidChannel: "Запрос на закрытие канала некорректен.",
        closeForbiddenGroup: "У вас нет прав закрыть эту группу.",
        closeForbiddenChannel: "У вас нет прав закрыть этот канал.",
        closeNotFoundGroup: "Эта группа больше не существует.",
        closeNotFoundChannel: "Этот канал больше не существует.",
        closeConflictGroup: "Закрытие группы конфликтует с параллельным изменением.",
        closeConflictChannel: "Закрытие канала конфликтует с параллельным изменением.",
        closeFailedGroup: "Не удалось закрыть группу. Повторите попытку.",
        closeFailedChannel: "Не удалось закрыть канал. Повторите попытку.",
        removeInvalidGroup: "Запрос на удаление группы некорректен.",
        removeInvalidChannel: "Запрос на удаление канала некорректен.",
        removeForbiddenGroup: "У вас нет прав удалить эту группу.",
        removeForbiddenChannel: "У вас нет прав удалить этот канал.",
        removeNotFoundGroup: "Эта группа больше не существует.",
        removeNotFoundChannel: "Этот канал больше не существует.",
        removeConflictGroup: "Удаление группы конфликтует с параллельным изменением.",
        removeConflictChannel: "Удаление канала конфликтует с параллельным изменением.",
        removeFailedGroup: "Не удалось удалить группу. Повторите попытку.",
        removeFailedChannel: "Не удалось удалить канал. Повторите попытку.",
      },
    },
    directDelete: {
      title: "Удалить этот личный чат",
      helper: "Это скроет личный чат только из вашего списка. Собеседник сохранит свой вид и историю.",
      confirmationLabel: "Введите {{phrase}} для подтверждения",
      confirmationPlaceholder: "Текст подтверждения",
      confirmationRequirement: "Кнопка удаления включается только после совпадения текста подтверждения.",
      actions: {
        cancel: "Отмена",
        delete: "Удалить чат",
        deleting: "Удаление...",
      },
      errors: {
        invalidRequest: "Запрос на удаление личного чата некорректен.",
        unauthorized: "Войдите снова, чтобы удалить этот чат.",
        notFound: "Этот чат уже недоступен.",
        conflict: "Этот чат уже удален из вашего списка.",
        failed: "Не удалось удалить этот личный чат. Повторите попытку.",
      },
    },
    secretEnvelope: {
      labels: {
        ratchetSessionId: "Идентификатор ratchet-сессии",
        ratchetCounter: "Счетчик ratchet",
        previousChainLength: "Длина предыдущей цепочки",
      },
      placeholders: {
        ratchetSessionId: "ratchet-session-1",
      },
      validation: {
        ciphertextRequired: "Текст секретного сообщения обязателен.",
        ratchetSessionIdRequired: "Для секретных сообщений обязателен идентификатор ratchet-сессии.",
        ratchetSessionIdInvalidPathSeparator: "Идентификатор ratchet-сессии содержит недопустимый разделитель пути.",
        ratchetCounterPositive: "Счетчик ratchet должен быть положительным числом.",
        previousChainLengthNonNegative: "Длина предыдущей цепочки должна быть нулем или больше.",
      },
      errors: {
        invalidEnvelope: "Секретный конверт некорректен. Проверьте поля ratchet и повторите.",
        ratchetOutOfSync: "Состояние ratchet рассинхронизировано. Обновите счетчики и повторите.",
        sendFailed: "Не удалось отправить секретное сообщение.",
      },
    },
    errors: {
      forbidden: "У вас нет доступа к этому чату.",
    },
  },
  profileAvatar: {
    eyebrow: "Профиль",
    title: "Фото профиля",
    youFallback: "Вы",
    previewAria: "Фото профиля: {{displayName}}",
    hints: {
      chooseForPreview: "Выберите изображение для предпросмотра перед заменой аватара.",
      selected: "Выбрано: {{fileName}}",
    },
    actions: {
      reload: "Обновить профиль",
      closePanel: "Закрыть панель профиля",
      chooseImage: "Выбрать изображение",
      replacePhoto: "Заменить фото",
      removePhoto: "Удалить фото",
    },
    feedback: {
      updated: "Фото профиля обновлено.",
      removed: "Фото профиля удалено.",
    },
    errors: {
      invalidRequest: "Неподдерживаемый формат изображения или тело запроса.",
      forbidden: "У вас нет прав на обновление этого профиля.",
      unauthorized: "Сессия истекла. Войдите снова.",
      reloadFailed: "Не удалось обновить профиль.",
      updateFailed: "Не удалось обновить фото профиля.",
      removeFailed: "Не удалось удалить фото профиля.",
    },
  },
  profileSettings: {
    sectionEyebrow: "Профиль",
    sectionTitle: "Настройки",
    displayNameLabel: "Видимое имя",
    displayNameHint: "Показывается в чатах и контактах перед никнеймом. Используйте 1-64 символа.",
    displayNameSave: "Сохранить видимое имя",
    displayNameSaving: "Сохранение видимого имени...",
    displayNameSaved: "Видимое имя сохранено.",
    displayNameInvalidError: "Используйте 1-64 символа для видимого имени.",
    displayNameSaveError: "Не удалось сохранить видимое имя.",
    nicknameLabel: "Никнейм",
    nicknameHint: "Используйте 3-32 буквы, цифры, подчеркивания или точки. Оставьте пустым, чтобы очистить.",
    nicknameSave: "Сохранить никнейм",
    nicknameSaving: "Сохранение никнейма...",
    nicknameSaved: "Никнейм сохранен.",
    nicknameTakenError: "Этот никнейм уже занят.",
    nicknameInvalidError: "Используйте 3-32 буквы, цифры, подчеркивания или точки.",
    nicknameSaveError: "Не удалось сохранить никнейм.",
    selectLabel: "Язык интерфейса",
    selectHint: "Выбранный язык сохраняется в вашем профиле.",
    optionRu: "Русский",
    optionEn: "Английский",
    themeLabel: "Тема",
    themeHint: "Выбранная тема сохраняется в вашем профиле.",
    optionLight: "Светлая",
    optionDark: "Темная",
    saving: "Сохранение...",
    saveError: "Не удалось сохранить язык интерфейса.",
    themeSaveError: "Не удалось сохранить тему интерфейса.",
  },
} as const;
